import { Theme } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

/**
 * Style rules of the toggle filters, kept apart from the components in
 * FilterToggleInput so that a consumer which cannot use those withStyles-wrapped
 * components still takes the same rules through makeStyles — see
 * pages/storage-ui/components/InventorizationModeToggle. One definition, so a
 * theme change cannot reach one toggle and miss another.
 */
export const filterToggleButtonStyle = (theme: Theme): CSSProperties => ({
  borderColor: theme.palette.primary.main,
  color: theme.palette.primary.main,

  '&:hover': {
    color: theme.palette.background.paper,
    backgroundColor: theme.palette.primary.light,
  },

  '&.Mui-selected': {
    color: theme.palette.background.paper,
    backgroundColor: theme.palette.primary.main,

    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
});

/** Toggle button that keeps its idle look when selected. */
export const filterNoToggleButtonStyle = (theme: Theme): CSSProperties => ({
  borderColor: theme.palette.primary.main,
  color: theme.palette.primary.main,

  '&.Mui-selected': {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
  },
});

export const filterToggleGroupStyle: CSSProperties = {
  marginBottom: 4,
};
